<div class="app-container">
  <page-header [icon]="'far-file-alt'" [title]="'stock.exports'">
    <ng-container class="header-button">
      <modal-print-export
        [exportType]="'stock-exports'"
        (resultExport)="createExportStocks($event)"
        [dataCyAttribute]="'add-inventory'"
      ></modal-print-export>
    </ng-container>
  </page-header>

  <section class="content">
    <div class="container-fluid ps-0 pe-0">
      <app-base-listing
        [listName]="'printStockExports'"
        [query]="queryStockExports"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
        (callAction)="callAction($event)"
      ></app-base-listing>
    </div>
  </section>
</div>
